import { useEffect, useState, useRef } from "react";
import { useAuth } from "@/hooks/useAuth";

export default function AuthCallback({ onComplete }) {
  const { processSessionFromHash } = useAuth();
  const [error, setError] = useState("");
  const [processing, setProcessing] = useState(false);
  const exchangeStarted = useRef(false);

  useEffect(() => {
    const hash = window.location.hash;
    if (!hash.includes("session_id=")) return;
    if (exchangeStarted.current) return;
    exchangeStarted.current = true;

    setProcessing(true);
    window.history.replaceState(null, "", window.location.pathname);

    processSessionFromHash(hash)
      .then((success) => {
        setProcessing(false);
        if (!success) {
          setError("Authentication failed. Please try again.");
        }
        onComplete();
      })
      .catch(() => {
        setError("Authentication failed. Please try again.");
        setProcessing(false);
      });
  }, [processSessionFromHash, onComplete]);

  if (error) {
    return (
      <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm">
        <div className="bg-zinc-950 border border-zinc-800 p-8 max-w-sm mx-4 text-center">
          <p className="text-sm text-red-400 font-mono mb-1">{error}</p>
          <p className="text-[11px] text-zinc-500 font-mono mb-4">Your session may have expired. Please try signing in again.</p>
          <button
            onClick={() => { setError(""); onComplete(); }}
            className="mt-2 px-4 py-2 text-[11px] font-mono uppercase tracking-wider border border-zinc-700 text-zinc-400 hover:text-zinc-200 hover:border-zinc-500 transition-colors"
            data-testid="auth-error-close"
          >
            Close
          </button>
        </div>
      </div>
    );
  }

  if (processing) {
    return (
      <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm">
        <div className="bg-zinc-950 border border-zinc-800 p-8 max-w-sm mx-4 text-center">
          <div className="inline-block w-5 h-5 border-2 border-zinc-700 border-t-zinc-100 rounded-full animate-spin mb-3" />
          <p className="text-xs font-mono text-zinc-500">Completing sign in...</p>
        </div>
      </div>
    );
  }

  return null;
}
